/*
Do stuff when certain scroll points are reached.
Different purpose than `IntersectionObserver`.
*/
const listeners = {
  onScroll: new Set(),
  onScrollUp: new Set(),
  onScrollDown: new Set(),
  onScrollIntoView: new Set(),
};
let previousScrollY = window.scrollY;

function onScroll(callback) {
  listeners.onScroll.add(callback);
}

function onScrollUp(callback) {
  listeners.onScrollUp.add(callback);
}

function onScrollDown(callback) {
  listeners.onScrollDown.add(callback);
}

function onScrollIntoView(callback) {
  listeners.onScrollIntoView.add(callback);
}

function emitOnScroll(direction) {
  for (const callback of listeners.onScroll) {
    callback(direction);
  }
}

function emitOnScrollUp() {
  for (const callback of listeners.onScrollUp) {
    callback();
  }
}

function emitOnScrollDown() {
  for (const callback of listeners.onScrollDown) {
    callback();
  }
}

function emitOnScrollIntoView() {
  for (const callback of listeners.onScrollIntoView) {
    callback();
  }
}

function isVisible(element) {
  const rect = element.getBoundingClientRect();

  return (
    rect.top > 0 && rect.top < window.innerHeight ||
    rect.bottom > 0 && rect.bottom < window.innerHeight
  );
}

/**
* @offsetTop - percentage
* @offsetBottom - percentage
*/
function getScrollPercent(element, { offsetTop, offsetBottom } = {}) {
  const rect = element.getBoundingClientRect();
  const elementTop = rect.top;
  const viewportBottom = window.innerHeight - (
    offsetBottom ? window.innerHeight * offsetBottom : 0
  );

  offsetTop = offsetTop ? window.innerHeight * offsetTop : 0;
  let scrollPercent = 1 - ((elementTop - offsetTop) / (viewportBottom - offsetTop));

  if (scrollPercent > 1) {
    scrollPercent = 1;
  }

  if (scrollPercent < 0) {
    scrollPercent = 0;
  }

  return scrollPercent;
}

function run() {
  window.addEventListener('scroll', () => {
    let direction = null;

    if (window.scrollY < previousScrollY) {
      direction = 'up';
      emitOnScrollUp();
    } else if (window.scrollY > previousScrollY) {
      direction = 'down'
      emitOnScrollDown();
    }

    emitOnScroll(direction);
    previousScrollY = window.scrollY;
  });
}


export const PageScrollWatcher = {
  run,
  onScroll,
  onScrollUp,
  onScrollDown,
  onScrollIntoView,
  isVisible,
  getScrollPercent,
};
